import React, {Component} from 'react'

class ErrorPage extends Component {

    render(){

        return (
            <div className="error-wrapper">
                <h1 className="error-title">Whoooops!</h1>
                <div className="error-subtitle">Sorry, an error has occurred! Our technicians are working for you, we'll be back soon!</div>
            </div>
        )
    }
}

export default ErrorPage;
